/**
 * Humanizes a next_event_at timestamp into a calm Swedish label.
 * - Same day: "Idag"
 * - Tomorrow: "Imorgon"
 * - Weekend (Sat/Sun within 7 days): "I helgen"
 * - Within 7 days: "Snart"
 * - Beyond 7 days or null: null
 */
export function humanizeEventDate(nextEventAt: string | null): string | null {
  if (!nextEventAt) return null;

  const now = new Date();
  const event = new Date(nextEventAt);
  const diffMs = event.getTime() - now.getTime();

  if (diffMs < 0) return null; // past

  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  if (diffDays > 7) return null;

  // Same calendar day
  if (
    event.getFullYear() === now.getFullYear() &&
    event.getMonth() === now.getMonth() &&
    event.getDate() === now.getDate()
  ) {
    return "Idag";
  }

  // Tomorrow
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (
    event.getFullYear() === tomorrow.getFullYear() &&
    event.getMonth() === tomorrow.getMonth() &&
    event.getDate() === tomorrow.getDate()
  ) {
    return "Imorgon";
  }

  // Weekend (Saturday = 6, Sunday = 0)
  const dayOfWeek = event.getDay();
  if (dayOfWeek === 0 || dayOfWeek === 6) {
    return "I helgen";
  }

  return "Snart";
}
